import { InputProps, SelectInput } from "react-admin"
import { BillStatusChoices } from "resources/billing/billing_constants"

const choices = [{ id: "null", name: "Not created" }, ...BillStatusChoices]

export const BillStatusInput: React.FC<InputProps> = (props) => (
  <SelectInput {...props} choices={choices} />
)
